import {
  ISpecialPopulation,
  ISpecialPopulationLookup,
} from '../interfaces/redux/ISpecialPopulation';

export const processSpecialPopulationsForDisplay = (
  specialPopulations: ISpecialPopulation[],
  specialPopulationLookups: ISpecialPopulationLookup[],
): Array<{ label: string; value: number; originalType: string }> => {
  if (!specialPopulations || specialPopulations.length === 0) {
    return [];
  }

  const shouldUseAbbreviations = specialPopulations.length > 1;

  return specialPopulations.map(pop => {
    let label = pop.type;

    if (shouldUseAbbreviations && specialPopulationLookups) {
      const lookupItem = specialPopulationLookups.find(
        (lookup: ISpecialPopulationLookup) => lookup.id === pop.special_population_id,
      );

      if (lookupItem?.abbreviation) {
        label = lookupItem.abbreviation;
      }
    }

    return {
      label,
      value: pop.id,
      originalType: pop.type,
    };
  });
};
